<template>
  <div>
    <label v-show="displayLabel">{{ label }}</label>
    <multiselect v-if="!isIE"
                 v-model="selectedValues"
                 :id="validationName"
                 :placeholder="placeholder"
                 v-validate="validationRules"
                 :data-vv-name="validationName"
                 :data-vv-as="validationTranslation"
                 :options="availableValues"
                 :disabled="disableCondition"
                 @input="onChange"
                 :track-by="fieldTrackBy"
                 :label="fieldLabel"
                 :showLabels="false"
                 open-direction="bottom"
                 :multiple="true"
                 :closeOnSelect="closeOnSelect"
                 :hide-selected="true">
      <span slot="noResult"> {{ $t("multiselect.no_result") }} </span>
    </multiselect>

    <v-select v-else
              multiple
              :value="selectedValues"
              :placeholder="placeholder"
              v-validate="validationRules"
              :data-vv-name="validationName"
              :data-vv-as="validationTranslation"
              :options="availableValues"
              :disabled="disableCondition"
              @input="onChange"
              :label="fieldLabel">
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const { detect } = require('detect-browser');

export default {
  name: 'UniversalMultiselect',
  props: {
    label: String,
    fieldLabel: String,
    fieldTrackBy: String,
    initialValues: Array,
    availableValues: Array,
    placeholder: String,
    validationRules: String,
    validationName: String,
    validationTranslation: String,
    disableCondition: Boolean,
    displayLabel: { type: Boolean, default: true },
    closeOnSelect: { type: Boolean, default: true },
  },
  inject: ['$validator'],
  data() {
    return {
      selectedValues: [...this.initialValues],
    }
  },
  watch: {
    initialValues: function(values) {
      this.selectedValues = [...this.initialValues];
    },
  },
  methods: {
    onChange(values) {
      this.$emit('change', values)
    },
    getOptionKey(option) {
      return "" + option.id + option.name;
    }
  },
  computed: {
    isIE() {
      if (detect()) {
        return detect().name == "ie"
      }
    },
  }
}
</script>
<style lang="scss">
  .vs__dropdown-option--selected {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/UniversalMultiselect.vue